<script>
  import LicenseTypeChip from '@/components/LicenseTypeChip/LicenseTypeChip';

  export default {
    name: 'CompanyPickerItem',

    components: { LicenseTypeChip },

    props: {
      company: {
        type: Object,
        required: true,
      },
      isActive: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      address() {
        const { corporateAddress } = this.company;

        return `${corporateAddress.address}
          ${corporateAddress.city} ,
          ${corporateAddress.state}
          ${corporateAddress.zipcode}`;
      },
    },
  };
</script>

<template>
  <div>
    <div class="text-small" :class="isActive ? 'color-teal' : 'color-ice'">
      {{ company.name }}
    </div>
    <div :class="['text-small ll-pb-1', $style.address, { 'color-teal': isActive }]">{{ address }}</div>
    <div class="flex flex-wrap">
      <LicenseTypeChip
        v-for="license in company.licenses"
        class="ll-mr-1 ll-mb-1"
        :key="license.id"
        :license="license"
        :title="license.number"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
  .address {
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
